import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { IBreadcrumb, breadcrumbOf } from '../navbar/navbar-state';
import { routes } from '../route-table/route-config';

// Where the page is in the menu: the section and the page (Production, Planning)
export const HeaderBreadcrumb = () => {

    const location = useLocation();
    const crumb : IBreadcrumb | undefined = breadcrumbOf(routes, location.pathname);

    return <nav className="header-breadcrumb" aria-label="Breadcrumb">
        {
            crumb
                ? <React.Fragment>
                    {
                        crumb.section
                            ? <React.Fragment>
                                <span>{ crumb.section }</span>
                                <i className="la la-angle-right" aria-hidden="true" />
                            </React.Fragment>
                            : null
                    }
                    <span className="current" aria-current="page">{ crumb.page }</span>
                </React.Fragment>
                : null
        }
    </nav>;
};
